"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDueDateFieldValue = exports.getDueDateFieldEmptyValue = void 0;
const getDueDateFieldEmptyValue = () => ({
    from_date: {
        date: null,
        include_time: false,
    },
    to_date: {
        date: null,
        include_time: false,
    },
    status_updated_on: null,
    status_is_completed: false,
});
exports.getDueDateFieldEmptyValue = getDueDateFieldEmptyValue;
const generateDueDateFieldValue = (value) => {
    var _a, _b, _c, _d;
    return {
        from_date: (_a = value.from_date) !== null && _a !== void 0 ? _a : {
            date: null,
            include_time: false,
        },
        to_date: (_b = value.to_date) !== null && _b !== void 0 ? _b : {
            date: null,
            include_time: false,
        },
        status_updated_on: (_c = value.status_updated_on) !== null && _c !== void 0 ? _c : null,
        status_is_completed: (_d = value.status_is_completed) !== null && _d !== void 0 ? _d : false,
    };
};
exports.generateDueDateFieldValue = generateDueDateFieldValue;
